import React from "react";

export default function SQLServer_ISNUMERIC() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQLServer_ISNUMERIC</h1>
      <p>This is the SQLServer_ISNUMERIC component generated from the SQL JSON.</p>
    </div>
  );
}
